import React from 'react'
import { classes, stylesheet } from 'typestyle'

import { GLOBAL_CONTENTS } from '../../../common/global-contents'

/* Hooks ======================================================================================== */
import useFetch from '../../../hooks/use-fetch'
import { useParams } from 'react-router-dom'
import useLocal from '../../../hooks/use-local'

/* Components =================================================================================== */
import { Box } from '../../../components/box/box.component'
import { Button } from '../../../components/button'
import { Modal } from '../../../components/modal'
import { Text } from '../../../components/text/text.component'
import { Heading } from '../../../components/text/heading.component'

/* Styles ======================================================================================= */
import { createMediaQuery } from '../../../components/style-class/style-class.utils'
import { mr8 } from '../../../styles/styleset/margin/mr8'
import { p12 } from '../../../styles/styleset/padding/p12'
import { pt0 } from '../../../styles/styleset/padding/pt0'
import { Line } from '../../../components/line'
import { mt12 } from '../../../styles/styleset/margin/mt12'
import { mb12 } from '../../../styles/styleset/margin/mb12'

Modal.add('Notification', (props: any) => {
  const { handleContentClick, item, onComplete } = props
  const params = useParams()

  const url = `${process.env.REACT_APP_API_URL}/a/groups/${params.groupId}/base/action-item/table/${item.id}`
  const [, $data] = useFetch({}, { url })
  const [local] = useLocal()

  return (
    <Box onClick={handleContentClick} rounded minWidth={320}>
      <Box className={classes(p12)} baseline="none">
        <Heading size="sm">{item.body.subject}</Heading>
      </Box>
      <Box className={classes(STYLES.container, p12, pt0)} baseline="none" fullWidth>
        <Box row fullWidth>
          <Line className={mb12} />
          <Text baseline="surface" size="md">
            <div dangerouslySetInnerHTML={{ __html: item.body.message }} />
          </Text>
          <Line className={classes(mt12, mb12)} />
        </Box>
        <Box baseline="none" spaceBetween>
          <Box />
          <Box column>
            <Button
              className={mr8}
              onClick={Modal.pop}
              label={GLOBAL_CONTENTS.close[local]}
              baseline="background"
              size="sm"
              square
            />
            <Button
              label={item.body.complete ? 'Mark Incomplete' : 'Mark Complete'}
              baseline="primary"
              size="sm"
              type="button"
              square
              onClick={async () => {
                const newItem = await $data.patch({
                  body: {
                    body: {
                      complete: !item.body.complete,
                    },
                  },
                })

                if (onComplete) {
                  onComplete(newItem)
                }

                Modal.pop()
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  )
})

const STYLES = stylesheet({
  container: {
    maxHeight: 420,
    overflow: 'auto',
    ...createMediaQuery['sm']({
      maxHeight: 360,
    }),
  },
})
